import { render, staticRenderFns } from "./upgrade-modal.vue?vue&type=template&id=139a1cd7&"
import script from "./upgrade-modal.vue?vue&type=script&lang=js&"
export * from "./upgrade-modal.vue?vue&type=script&lang=js&"
import style0 from "./upgrade-modal.vue?vue&type=style&index=0&id=139a1cd7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports